import { gql } from '@apollo/client';

export const SredPayrollExpenseFragment = gql`
  fragment SredPayrollExpense on SredPayrollExpense {
    id
    name
    title
    department
    managerName
    hireDate
    terminationDate
    costCenter
    entity
    wageType
    province
    sredEmployeeType
    qualifiedAmountCents
    amountCents
    sredEligiblePercentage
    payrollProvider
    ticketingProviders
    sredCategory
    sredContributorId
    sredPayrollExpenseId
    sredTaxCreditId
  }
`;
